import {
  ApplicationConfig,
  provideZoneChangeDetection,
  importProvidersFrom,
  isDevMode,
  ErrorHandler,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import {
  provideClientHydration
} from '@angular/platform-browser';
import {
  provideHttpClient,
  withFetch,
  withInterceptors,
} from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { authInterceptor } from './auth.interceptor';
import { provideStore } from '@ngrx/store';
import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { productsReducer } from './state/products/products.reducer';
import { ProductsEffects } from './state/products/products.effects';
import { adminProductsReducer } from './state/admin-products/admin-products.reducer';
import { AdminProductsEffects } from './state/admin-products/admin-products.effects';
import { ordersReducer } from './state/orders/orders.reducer';
import { OrdersEffects } from './state/orders/orders.effects';
import { adminOrdersReducer } from './state/admin-orders/admin-orders.reducer';
import { AdminOrdersEffects } from './state/admin-orders/admin-orders.effects';
import { publicCategoriesReducer } from './state/categories/public-categories.reducer';
import { PublicCategoriesEffects } from './state/categories/public-categories.effects';
import { adminCategoriesReducer } from './state/categories/admin-categories.reducer';
import { AdminCategoriesEffects } from './state/categories/admin-categories.effects';

import { GlobalErrorHandler } from './core/global-error-handler';
import { provideServiceWorker } from '@angular/service-worker';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideClientHydration(),
    provideHttpClient(withInterceptors([authInterceptor]), withFetch()),
    provideAnimations(),
    importProvidersFrom(
      ToastrModule.forRoot({
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
        preventDuplicates: true,
        progressBar: true,
      }),
    ),
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    provideStore(),
    provideState({ name: 'products', reducer: productsReducer }),
    provideState({ name: 'adminProducts', reducer: adminProductsReducer }),
    provideState({ name: 'orders', reducer: ordersReducer }),
    provideState({ name: 'adminOrders', reducer: adminOrdersReducer }),
    provideState({
      name: 'publicCategories',
      reducer: publicCategoriesReducer,
    }),
    provideState({ name: 'adminCategories', reducer: adminCategoriesReducer }),
    provideEffects([
      ProductsEffects,
      AdminProductsEffects,
      OrdersEffects,
      AdminOrdersEffects,
      PublicCategoriesEffects,
      AdminCategoriesEffects,
    ]),
    provideStoreDevtools({ maxAge: 25, logOnly: !isDevMode() }),
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000',
      scope: './',
    }),
  ],
};
